/**
 * Store for `DATA.audiences`
 * @module
 */

var _ = require('optimizely-client-fn');
var actionTypes = require('../constants/action_types');
var freeze = require('../utils/freeze');

function getAudienceConditions(conditions, res?) {
  if (!res) {
    res = {} as any;
  }

  if (!conditions) {
    return res;
  }

  _.each(conditions, function(cond) {
    if (_.isString(cond)) {
      return;
    }

    if (_.isObject(cond)) {
      var type = cond.type;
      var name = cond.name || '_';
      if (!res[type]) {
        res[type] = {} as any;
      }
      res[type][name] = true;
    }

    if (_.isArray(cond)) {
      getAudienceConditions(cond, res);
    }
  });

  return res;
}

/**
 * Holds the data for every layer
 */
module.exports = {
  initialize: function() {
    this.__state = {
      audiences: {},
      featuresNeeded: {},
    };

    this.on(actionTypes.DATA_LOADED, this.__loadData);
  },

  /**
   * Loads layer data into the store state
   * @param {Object} payload
   * @param {ClientData} payload.data
   * @private
   */
  __loadData: function(payload:any) {
    if (_.isEmpty(payload.data.audiences)) {
      return;
    }
    _.each(payload.data.audiences, _.bind(function(audience) {
      freeze.deepFreeze(audience);
      _.merge(this.__state.featuresNeeded, getAudienceConditions(audience.conditions));
      this.__state.audiences[audience.id] = audience;
    }, this));
    this.emitChange();
  },

  /**
   * @return {Audience[]}
   */
  getAll: function(): Audience[] {
    return freeze.safeReference(_.values(this.__state.audiences));
  },

  /**
   * Get all "name" values for a given "type" value across all audiences
   * @param {string} type
   * @return {Object.<boolean>} Map of "name" (or "_" if no name given) to the value `true`
   */
  getFeaturesNeeded: function(type:string): Record<string, boolean> {
    return freeze.safeReference(this.__state.featuresNeeded[type] || {});
  },

  getAudiencesMap: function() {
    return freeze.safeReference(this.__state.audiences);
  },

  /**
   * @param {string} id
   * @return {Audience}
   */
  get: function(id:string): Audience {
    return freeze.safeReference(this.__state.audiences[id]);
  },

  /**
   * @param {string} id
   * @return {string}
   */
  getAudienceName: function(id:string): string {
    var aud = _.find(_.values(this.__state.audiences), {
      id: id,
    });
    // TODO(tyler): remove default if audience name is nullable in Avro
    return aud.name || 'Aud ' + id;
  },
};
